import createNumberMask from 'text-mask-addons/dist/createNumberMask';

// Mask CPF
export const cpfMask = 
  [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]

// Mask CNPJ
export const cnpjMask = 
  [/\d/, /\d/,'.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]

// Mask CellPhone
export const phoneNumberMask = 
  ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

// Mask credit card default
export const defaultCreditCardMask = 
  [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]

// Mask Agency (45 - Banco do Brasil)
export const agencyBankMask = 
[/\d/, /\d/, /\d/, /\d/, '-', /\d/]

// Mask Currency
export const currencyMask = () => {
	return ['R','$',' ', /\d/, /\d/, ',', /\d/, /\d/];
}

// Mask Miles
export const milesMask = createNumberMask({
	prefix: '',
	suffix: '',
	includeThousandsSeparator: true,
	thousandsSeparatorSymbol: '.',
	integerLimit: 7,
	allowLeadingZeroes: true
})

// Mask para manter apenas números no campo
export const patternOnlyNumbers = /[0-9]+/g;